<div class="actions-container">
    <button  mat-raised-button class="new-button" (click)="addNewAsset()">New Asset</button>
</div>